import React from "react";
import Footer from "../Components/Footer.js";
import Hiring from "../Components/Hiring.js";
import NavBar from "../Components/NavBar.js"
import NoOpenJobs from "../Components/NoOpenJobs.js";
import WhyJoinUs from "../Components/WhyJoinUs.js";

const Careers=()=>{
    return(
        <>

        <div className="pages">
  <NavBar />

            <div id="careers-page">

<section>
 <div id="culture"  className="light-background">
<h1>Why Join Us?</h1>
<WhyJoinUs/>
            </div>
            <div id="hiring-process"  className="light-background">
                <h1>Our Hiring Process</h1>
                <Hiring/>
            </div>
            <div id="open-positions"  className="light-background" >
                <h1>Vacancies</h1>
                <NoOpenJobs/>

            </div>

</section>

<section>

</section>
            </div>
           
        </div><Footer /></>
    )
    }
export default Careers;